import axios from "axios";
import { env } from "../env";

const instance = axios.create({
  baseURL: env.REACT_APP_BASEURL_NEW,
});
export default instance;
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
